import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import type { IOutrightTournamentResult, IResult } from '@/interface/IResult';
import { SportType } from '@/interface/enum';

export function getGroupedResults(results: IResult[]) {
    const sorted = orderBy(results, result => getSortingMatchCode(result), 'asc');

    const grouped = Object.entries(groupBy(sorted, result => result.leagueId));

    const sortedLeagues = orderBy(grouped, ([_, results]) => getSortingMatchCode(results[0]), 'asc');

    return sortedLeagues
        .map(([leagueId, results]) => ({
            id: parseInt(leagueId),
            title: results[0].leagueName,
            results: orderBy(results, result => result.showTime, 'asc'),
        }));
}

export function getGroupedOutrightResults(results: IOutrightTournamentResult[]) {
    const groups = Object.entries(groupBy(results, result => result.id));

    const groupedData = groups.map(([id, results]) => ({
        tournamentId: parseInt(id),
        title: results[0].name,
        results: orderBy(results.flatMap(result => result.outrights), outright => outright.eventDate, 'asc'),
    }));

    return orderBy(groupedData, result => result.results[0].matchCode, 'asc');
}

/**
 * All soccer match codes are in the format of "\d\d\d\d-eLLLLYYMMDDxxxx" (e.g. 0027-e00012345678)
 * - LLLL: league code
 * - YYMMDD: match date
 * - xxxx: match code
 *
 * The digits before dash are for odds display priority, the code after dash is for result sorting.
 * For soccer, sort by matchCodeWithoutLeaguePriority only.
 * For other sports, sort by `{leaguePriority}-{matchCodeWithoutLeaguePriority}`.
 */
function getSortingMatchCode(result: IResult) {
    if (result.sportType === SportType.Soccer) {
        return result.matchCodeWithoutLeaguePriority;
    }

    return `${result.leaguePriority}-${result.matchCodeWithoutLeaguePriority}`;
}
